<template>
  <div class="home">
    <div class="back flex" @click="$router.go(-1)">
      <span class="iconfont icon-arrow-lift"></span>
      <span>返回</span>
    </div>
    <headType @change="changeType" v-if="config.topMenu" />
   
    <sMap  
    v-if="showMap"
    ref="maphome"
    :show-line="curPage == 'path'"
    :coordType="coordType"
    :clockId="clockId"
    :curId = "urlid"
    :mapCenter = 'mapCenter'
    @markclick="markClick" />
    
    <transition name="fade">
      <s-notice @hide="hideNotice" v-show="showNotice ">爱国主义主题数字阅读体验空间已正式上线！</s-notice>
    </transition>
    <s-tabbar :page="curPage" @change="changeTabbar" v-if="config.false" ></s-tabbar>
 
    <s-rightmenu @change="changeRightMenu" v-if="config.slideMenu"></s-rightmenu>

    <van-popup v-model="showConcat">
      <s-concat @hide="()=>{showConcat = false}"></s-concat>
    </van-popup>

    <!-- :close-on-click-overlay="false" -->
    <van-popup v-model="showAdvice" >
      <s-advice @hide="()=>{showAdvice = false}"></s-advice>
    </van-popup>
    <!-- 音频小窗口 -->
      <s-intro-small 
        :snum="snum"
        ref="smallIntro"
        v-if="showSmallIntro"
        :id="markedId"
        @hide="hideSmallIntro"  
        @show-detail="showIntroDetail"
        @clock="clickClock"></s-intro-small>

    <!-- <van-popup v-model="showIntroBig" position="bottom" :close-on-click-overlay="false"> -->
      <s-intro-big 
        v-show="showIntroBig"
        :id="moreId" 
        :key="moreId" 
        ref="bigIntro"
        @hide="()=>{showIntroBig = false}"
        @share="popshare" 
        @clock="clickClock"
        @change="changeVideo"
        @openvr="openvr"
        @changeMedia="changeMedia"></s-intro-big>
    <!-- </van-popup> -->

    <van-popup v-model="showClock" position="bottom" round :overlay="false">
      <s-clock @hide="()=>{showClock = false}" @clock="clickClock" :markedId="markedId" :clockId="clockId"></s-clock>
    </van-popup>

    <van-popup v-model="showVideo" position="right" >
      <!-- <s-video @hide="()=>{showVideo = false}" :show="showVideo" ></s-video> -->
      <s-ar @hide="()=>{showVideo = false}" :show="showVideo" @changeMode="changeMode"></s-ar>
    </van-popup>

    <van-popup v-model="showFeature" position="right">
      <s-feature @hide="hideFeature" :show="showFeature" :newlist="newVideo"></s-feature>
    </van-popup>
    

    <van-popup v-model="showVr" position="right">
      <s-vr @hide="()=>{showVr = false}" :show="showVr" @changeMode="changeMode"></s-vr>
    </van-popup>

    <van-popup v-model="showVrone" position="right">
      <s-vr-one @hide="()=>{showVrone = false}" :show="showVrone" :src="vroneSrc"></s-vr-one>
    </van-popup>
    
    <s-audio ref="audioControl"></s-audio>
    <s-cover :isshare="isshare" @click="closeCover"></s-cover>

    <van-popup v-model="showOrder" position="bottom" round >
      <s-order @hide="()=>{showOrder = false}"></s-order>
    </van-popup>
    
    <van-popup v-model="showGlue" position="right">
      <s-newInfo @hide="()=>{showGlue = false}"></s-newInfo>
    </van-popup>

    <!-- <div class="pop-up" v-show="showgongl">
      <s-gongl @hide="()=>{showgongl = false}" @show="showClick"></s-gongl>
    </div> -->
    <!-- <div class="getbtn" @click="goCoord">采点</div> -->
  </div>
</template>
<script>
import config from "@/config"
import { mapState,mapGetters,mapMutations } from 'vuex';
import wx from "weixin-js-sdk"
import SNotice from '@/components/s-notice.vue'
import STabbar from '@/components/s-tabbar.vue'
import sRightmenu from '@/components/s-rightmenu/s-rightmenu.vue'
import sConcat from '@/components/s-concat.vue'
import sAdvice from '@/components/s-advice.vue'
import sIntroSmall from '@/components/s-introsingle/s-intro-small.vue'
import sIntroBig from '@/components/s-introsingle/s-intro-big.vue'
import SClock from '@/components/s-clock/s-clock.vue'
import SVr from '@/components/s-vr/s-vr.vue'
import SAudio from '@/components/s-audio.vue'
import MapHomeVue from '@/components/m-map/MapHome.vue'
import SFeature from '@/components/s-feature.vue'
import SAr from '@/components/s-ar.vue'
import sCover from '@/components/s-cover.vue';
import sOrder from '@/components/s-order/s-order.vue';
import sVrOne from '@/components/s-vr/s-vr-one.vue';
import sNewInfo from '@/components/s-newInfo.vue';
import sGongl from '@/components/s-gongl/s-gongl-pop.vue';
import sMap from "./components/map.vue" 
import headType from './components/headType.vue';
let setintervalTime;
export default {
  components:{
    SNotice,
    STabbar,
    sRightmenu,
    sConcat,
    sAdvice,
    sIntroSmall,
    sIntroBig,
    SClock,
    SVr,
    SAudio,
    MapHomeVue,
    SFeature,
    SAr,
    sCover,
    sOrder,
    sVrOne,
    sNewInfo,
    sGongl,
    sMap,
    headType,
     },
    data(){
      return{
        config,
        showNotice:false,
				showConcat:false,
				showSmallIntro:false,
        showIntroBig:false,
        showAdvice:false,
        showClock:false,
        showVideo:false,
        showFeature:false,
        showVr:false,
        showOrder: false,
        curPage:'home',
        playMusic:false,
        markedId:'',
        playMusicId:'',
        barrageR:0,
        sendBarrage:"",
        coord: [],
        videoType:0,
        moreId: '',
        isshare: false,
        urlid: '',
        clockId: '',
        newVideo: null,
        snum: null,
        showVrone: false,
        vroneSrc:null,
        updateTime: new Date().getTime(),
        updateTimestat: new Date().getTime()+123,
        showGlue: false,
        showgongl: false,
        coordType:-1 ,//坐标点类型,
        showMap:false,
        defaultAudio:{
          id:0,
          name:'爱国主义主题数字阅读体验空间',
          src:'http://huitongimg.wanjuan.cn/img/2024/11/4/97205248-dc82-46b3-b04e-acb34f0e3c87.mp3'
        },
        mapCenter:'',
      }
    },
    computed:{
      ...mapGetters("audio", {
        audioPercent: "getPercent",
        curPlay: 'getCurAudio',
      }),
      ...mapState("audio",{
        audioDuration:"audioDuration",
        audioCurrentTime:"audioCurrentTime",
        audioPlay:"playState",
        isRandom:"playOrder"
      })
    },
    watch:{
      $route:{
        handler(newv,oldv){
          if(newv && newv.name=='Home'){
            if(newv.query.mode){
              this.curPage='home'
              if(newv.query.mode=='map'){
                this.showVr = false
                this.showVideo = false
              }
              if(newv.query.mode=='vr'){
                this.showVr = true
                this.showVideo = false
              }
              if(newv.query.mode =='ar'){
                this.showVideo = true
                this.showVr = false
              }
            }
          }
        },immediate:true
      }
    },
    beforeRouteEnter (to, from, next){
      next(vm => {
        vm.fromPath = from.name
      })
    },
    activated(){
      let mode = this.$route.query.mode
      this.curPage='home'
      if(mode=='vr'){
        this.showVr = true
        this.showVideo = false
      }
      if(mode=='ar'){
        this.showVideo = true
        this.showVr = false
      }
      if(mode=='map'){
        this.showVr = false
        this.showVideo =false
        if(this.fromPath=='order'){this.updateTime = new Date().getTime()};
        if(this.audioPlay){
          this['audio/updatePlayState'](false)
        }else{
          this['audio/updatePlayState'](true)
        }
      }
    },
    async mounted() {
      let spot = this.$utils.getParams('spot')
      if(spot){

      }

      let id = this.$utils.getParams('sid');
      let stype = this.$utils.getParams('type');
      let snum = this.$utils.getParams('num');
      this.coordType = this.$utils.getParams("coordType") || 79;
      if(!id&&stype=='vr'){
        this.showVr = true;
      }
      if(!id&&stype=='ar'){
        this.showVideo = true;
      }
      this.showMap =true
      if(id||(id&&snum)){
        this.markedId = id;
        this.urlid = id;
        if(stype!='video'&&stype!='vr')this.showSmallIntro = true;
        if(stype=='audio')this.snum = snum;
        if(stype=='video'||stype=='vr'){
        this.$api.mapApi.getSpotById(id).then(async data=>{
          if(data){
          let dataInfo = data;
          if(stype=='video') {
            let videoNum = snum?Number(snum)-1:0;
            let arr = dataInfo.mp4_list;
            if(arr.length<=0) return;
            let obj = arr.find((res,i)=>{return i==videoNum});
            let params = {
              name:obj.name,
              media_path:data.showpath+obj.media_path,
              introduce:""
            }
            this.changeVideo(params)
          }
          if(stype=='vr'){
            let videoNum = snum?Number(snum)-1:0;
            let arr = dataInfo.vr_list;
            if(arr.length<=0) return;
            let obj = arr.find((res,i)=>{return i==videoNum});
            let src = obj.media_path;
            this.openvr(src);
          }
          }
        });
        }
      }else if(stype=='ar'||stype=='vr'){}else{
        // this['audio/updatePlayInfo']({ ...this.defaultAudio})
        // this['audio/updatePlayState'](true);
      }
      // this.showNotice = true

      
      setTimeout(() => {
        this.hideNotice()
      }, 5000);
      
      this.showgongl = true;
    },
    
    beforeDestroy() {
      clearInterval(setintervalTime);
      setintervalTime = '';
      this.$refs.audioControl && this.$refs.audioControl.stopAudioHome();//停止音频
    },
    methods: {
      ...mapMutations(['audio/updatePlayInfo','audio/updatePlayState']),
      showClick(e){
        this.showGlue = e;
        this.showgongl = false;
      },
      hideNotice(){
					this.showNotice = false
				},
      changeVideo(e){
        this.newVideo = e;
        setTimeout(() => {
          this.showFeature = true;
        }, 200);
      },
      openvr(e){
        this.vroneSrc = e;
        setTimeout(() => {
          this.showVrone = true;
        }, 200);
      },
      changeMedia(index){
        this.snum = Number(index)+1;
      },
      hideFeature(){
        if(this.newVideo){
          this.newVideo  = null;
        }
        this.showFeature = false;
      },

      changeRightMenu(e){
        let type = e.event
        if(type=='glue'){
          this.showGlue = true
        }
        if(type=="concat"){
          this.showConcat = true
        }
        if(type=="advice"){
          this.showAdvice = true
        }
        if(type=="clock"){
          this.showClock = true
        }
        if(type=='feature'){
          this.showFeature = true;
        }
        if(type=='ar'){
          this.showVideo = true
          this.$refs.audioControl.stopAudioHome()
        }
        if(type=='vr'){
          this.showVr = true
          this.$refs.audioControl.stopAudioHome()
        }
        if(type=='audio'){
          if(!this.playMusic){
            this.playMusic = true
          }
          this.showSmallIntro = true
          this.markedId = this.curPlay.id;
        }
        if(type=='aim'){
          // console.log('点击了定位');
          this.mapCenter = new Date().getTime()
        }
        if(type=='back'){
          // console.log('点击了定位');
          this.$router.go(-1)
        }
        if(type=="scan"){
          // this.$router.push("/Write")
          wx.miniProgram.navigateTo({url: '/pages/write/write'})
        }
      }, 
      hideArPannel(){
        this.showVideo = false
        this.showBriefMp3()
      },
      showBriefMp3(){
        if(!this.curPlay){
          this['audio/updatePlayInfo']({
            ...this.defaultAudio,
            isIntro:true,
          })
        }
        
      },
      
      clickClock(e){
      //  this.showClock = false;
        this.clockId =  e;
        this.markedId = e;
        if(this.$refs.smallIntro && this.$refs.smallIntro.playInfo.id == e){
          this.$refs.smallIntro.clockState = true
        }
        if(this.$refs.bigIntro &&this.$refs.bigIntro.scenic_id == e){
          this.$refs.bigIntro.clocked = true
        }
        this.updateTimestat = new Date().getTime()+123;
      },
      hideSmallIntro(){
        this.showSmallIntro = false
      },
      // 音频-更多
      showIntroDetail(e){
        this.showIntroBig= true;
        this.moreId = e;
        this.xx = true
      },

      changeTabbar(type){
        if(type=='share'){
          this.isshare = true
          this.share()
          return
        }
        if(type=='order'){
          // this.showOrder= true
          this.$router.push("/order?openid="+window.openid)
          return
        }
        if(type == 'path'){
          if(this.curPage==type) {this.curPage = 'home'}
          else{this.curPage = type}
        }
      },

      changeMode(e){
        this['audio/updatePlayState'](false);
        if(e.new=='ar'){
          this.showVideo = true
          setTimeout(() => {
            this.showVr = false
          }, 100);
        }
        if(e.new=='vr'){
          this.showVr = true
          setTimeout(() => {
            this.showVideo = false
          }, 100);
        }
      },

      //点击地图上的点
      markClick(e){
        if(e){
          // console.log("打卡点",e)
          this.markedId = e.id
          // this.showSmallIntro = true
          this.snum = null;
          this.$nextTick(()=>{
            this.showIntroDetail(e.id)
          })
        }
      },
      addBarrage(content){
        this.$refs.barrageTop.add(content);
        this.updateTimestat = new Date().getTime()+123;
      },
      delchange(e){
        this.$refs.barrageTop.del(e);
      },
      
      // 关闭遮罩层
      closeCover(e){
        this.isshare = e;
      },

      // this.coord = coord;

      //切换顶部分类
      changeType({item,index}){
        this.coordType = item.id
      },
      // 音频分享
      popshare(e){
        this.isshare = true;
        this.share(e.sid,e.title,e.imgpath);
      },
      // 分享
      share(sid,title,imgpath){
        try{
            wx.miniProgram.postMessage({
                data: {
                    'title': title,
                    'sid': sid,
                    'imgPath': imgpath
                }
            });
        }catch(err){}
      },

      goCoord(){
        this.$router.push("/coordinate")
      },
      
      
    },
}
</script>
<style lang="scss">
.home{
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100vh
}

.getbtn{
  position: fixed;
  right:10px;
  bottom: 150px;
  z-index: 50;
  width: 60px;
  height: 60px;
  background: rgb(34, 132, 212);
  color:#fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back{
  position: fixed;
  left: 30px;
  z-index: 10;
  top: 30px;
  background: #fff;
  color:rgb(34, 132, 212) ;
  height: 30px;
  border-radius: 30px;
  padding: 0 20px;
  .iconfont{
    font-size: 18px;
  }
}
</style>